import {
  useState,
  useEffect,
  useRef,
  RefObject,
  Dispatch,
  SetStateAction,
} from 'react';

/** Хук, чтобы детектить клики вне дом-узла и скрывать/показывать элемент */
export function useOutsideClicker<RefType extends HTMLElement>(
  initialIsVisible: boolean,
  ignoredClass?: string
): {
  ref: RefObject<RefType>;
  isComponentVisible: boolean;
  setIsComponentVisible: Dispatch<SetStateAction<boolean>>;
} {
  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);
  const ref = useRef<RefType>(null);

  const handleClickOutside = (event: MouseEvent): void => {
    if (
      ref.current &&
      !ref.current?.contains(event.target as HTMLElement) &&
      (!ignoredClass ||
        !(event.target as HTMLDivElement).closest(`.${ignoredClass}`))
    ) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return { ref, isComponentVisible, setIsComponentVisible };
}
